import moment from 'moment';

export class RequestListMapExcel {
  static mapExcel(jsonData, isRetailer: boolean) {
    return jsonData.map((val) => {
      if (isRetailer) {
        return {
          'ID pedido': val.requestMainId,
          CPE: val.requestCpe,
          'Estado atual': val.statusTitle,
          'Área atual': val.requestArea,
          'Tipo atual': val.requestType,
          'Sub-tipo atual': val.requestSubType,
          'Criado por': val.createdBy,
          'Data de criação': val.createdAt ? moment.utc(val.createdAt).local().format('YYYY-MM-DD HH:mm:ss') : '',
          'Data da última resposta': val.lastResponseDate
            ? moment.utc(val.lastResponseDate).local().format('YYYY-MM-DD HH:mm:ss')
            : '',
          'Resposta criada por': val.lastResponder,
        };
      } else {
        return {
          'ID pedido': val.requestMainId,
          'Estado atual': val.statusTitle,
          Comercializador: val.retailerName,
          CPE: val.requestCpe,
          'Nível de tensão atual': val.voltageLevelName,
          'Pasta atual': val.folderTitle,
          'Área atual': val.requestArea,
          'Tipo atual': val.requestType,
          'Sub-tipo atual': val.requestSubType,
          'Criado por': val.requestTransactionUser ? val.requestTransactionUser : val.createdBy,
          'Data de criação': val.createdAt ? moment.utc(val.createdAt).local().format('YYYY-MM-DD HH:mm:ss') : '',
          'Atribuído a': val.assignedUserName,
          'Data da última resposta do comercializador': val.lastRetailerResponseDate
            ? moment.utc(val.lastRetailerResponseDate).local().format('YYYY-MM-DD HH:mm:ss')
            : '',
          'Data da última resposta EDP': val.lastOrdResponseDate
            ? moment.utc(val.lastOrdResponseDate).local().format('YYYY-MM-DD HH:mm:ss')
            : '',
          'Última Resposta EDP': val.lastOrdResponseUser,
          'Pedido reaberto': val.alreadySolved,
          Descrição: val.description,
        };
      }
    });
  }
}
